export default function(str) {
  if (str.length > 40) {
    return str.substr(0, 29) + '...' + str.substr(str.length - 8, str.length - 1)
  } else {
    return str
  }
}